module.exports = __webpack_public_path__ + "static/slide-3-fa27d588dbb27b00e799f960c3fdbba7.png";